<script>
export default {
    name: "FeatureFlag",
    props: {
        id: String,
        name: String,
        description: String,
        flagtype: String,
        userlist: String,
        adminlist: String,
        percentage: String,
        active: String,
        debtdate: String
    },
    data() {
        return {
            axios: window.axios,
            users: [],
            admins: [],
            admin_selected: [],
            user_selected: [],
            show_error: false,
            error_message: '',
            show_success: false,
            success_message: '',
            show_working: false,
            percentage_value: '',
        }
    },

    mounted() {
        if (this.userlist != undefined) {
            this.users = JSON.parse(this.userlist);
        }
        this.admins = JSON.parse(this.adminlist).sort();
        this.percentage_value = this.percentage;
    },

    methods: {
        addClicked: function() {
            if (this.name == '') {
                this.showError("Name must be entered")
                return;
            }

            const data = {
                name: this.name,
                description: this.description,
                flagtype: this.flagtype,
                userlist: this.users,
                percentage: this.percentage,
                active: this.active,
                debtdate: this.debtdate
            };

            this.show_working = true;

            window.axios.post('/app/admin/features', data)
                .then(response => {
                    console.log(response);
                    let data = response.data;
                    if (data.status === 'success') {
                        this.showSuccess("Added Successfully");
                        location.reload();
                    } else if (data.status === 'error') {
                        this.showError(data.error.message);
                    }

                    this.show_working = false;
                })
                .catch(error => {
                    this.showError(error.response.data);
                });
        },

        updateClicked: function() {
            const data = {
                name: this.name,
                description: this.description,
                flagtype: this.flagtype,
                userlist: this.users,
                percentage: this.percentage,
                active: this.active,
                debtdate: this.debtdate
            };

            this.show_working = true;

            window.axios.put('/app/admin/features/'+this.id, data)
                .then(response => {
                    let data = response.data;
                    if (data.status === 'success') {
                        this.showSuccess("Flag updated successfully");
                    }
                    this.show_working = false;
                })
                .catch(error => {
                    this.showError(error.response.data);
                });
        },


        deleteClicked: function() {
            if ( ! confirm("Delete flag "+this.name+"?")) {
                return;
            }

            this.show_working = true;
            window.axios.delete('/app/admin/features/'+this.id)
                .then(response => {
                    let data = response.data;
                    if (data.status === 'success') {
                        this.showSuccess("Deleted Successfully");
                        location.reload();
                    }
                    this.show_working = false;
                })
                .catch(error => {
                    this.showError(error.response.data);
                });
        },

        showError: function(message) {
            this.show_error = true;
            this.error_message = message;
            setTimeout(()=>{ this.show_error=false; this.show_working = false; }, 10000);
        },

        showSuccess: function(message) {
            this.show_success = true;
            this.success_message = message;
            setTimeout(()=>{ this.show_success=false; this.show_working = false; }, 5000);
        },

        usersAddAll: function() {
            for (const a of this.admins) {
                this.users.push(a);
            }
            this.admins = [];
            this.users.sort();
        },

        usersRemoveAll: function() {
            for (const a of this.users) {
                this.admins.push(a);
            }
            this.users = [];
            this.admins.sort();
        },

        usersAddSelected: function() {
            if (this.admin_selected.length==0) {
                return;
            }
            this.users.push(this.admin_selected[0]);
            const index = this.admins.indexOf(this.admin_selected[0]);
            this.admins.splice(index, 1);
            this.users.sort();
        },

        usersRemoveSelected: function() {
            if (this.user_selected.length==0) {
                return;
            }
            this.admins.push(this.user_selected[0]);
            const index = this.users.indexOf(this.user_selected[0]);
            this.users.splice(index, 1);
            this.admins.sort();
        }
    }
}
</script>

<template>
    <div>
        <div style="clear: both;margin-bottom: 10px;">
            <div style="float: left; width: 120px;">
                <div style="float: left;">Feature Name</div>
                <info-tooltip margin-left="50px">
                    <p>
                        Name of the flag, used in code
                    </p>
                </info-tooltip>
            </div>
            <input placeholder="Feature Name" v-model="name" v-if="id==0">
            <span v-if="id>0">{{ this.name }}</span>
        </div>
        <div style="clear: both;margin-bottom: 10px;">
            <div style="float: left; width: 120px;">
                <div style="float: left;">Description</div>
                <info-tooltip margin-left="50px">
                    <p>
                        Free-text description or comments about the flag
                    </p>
                </info-tooltip>
            </div>
            <input style="width: 350px;" placeholder="Description" v-model="description">
        </div>
        <div style="clear: both; margin-bottom: 10px;">
            <div style="float: left; width: 120px;">
                <div style="float: left;">Type</div>
                <info-tooltip margin-left="50px">
                    <p>
                        Indicator of how the flag gets applied.<br>
                        <b>System</b>: either on or off<br>
                        <b>User</b>: applied to specific users<br>
                        <b>Percentage</b>: applied to users based on a random number
                    </p>
                </info-tooltip>
            </div>
            <select v-model="flagtype">
                <option value="system">System</option>
                <option value="user">User Groups</option>
                <option value="percentage">Percentage</option>
            </select>
        </div>
        <div v-if="flagtype=='user'" style="clear: both;">
            <div style="float: left; width: 120px;">
                <div style="float: left;">Users</div>
                <info-tooltip margin-left="50px">
                    <p>
                        Users on the left are available to apply,
                        users on the right receive the flag
                    </p>
                </info-tooltip>
            </div>
            <div style="float: left; margin-bottom: 10px;">
                <select v-model="admin_selected" multiple style="width: 200px; height: 140px; float: left;">
                    <option v-for="a in admins" :key="a">{{ a }}</option>
                </select>

                <div style="width: 30px; float: left;">
                    <div style="cursor: pointer;" @click="usersAddAll" title="add all users">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>chevron-double-right</title><path d="M5.59,7.41L7,6L13,12L7,18L5.59,16.59L10.17,12L5.59,7.41M11.59,7.41L13,6L19,12L13,18L11.59,16.59L16.17,12L11.59,7.41Z" /></svg>
                    </div>
                    <div style="cursor: pointer;" @click="usersAddSelected" title="add selected">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>chevron-right</title><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>
                    </div>
                    <div style="cursor: pointer;" @click="usersRemoveSelected" title="remove selected">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>chevron-left</title><path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>
                    </div>
                    <div style="cursor: pointer;" @click="usersRemoveAll" title="remove all users">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>chevron-double-left</title><path d="M18.41,7.41L17,6L11,12L17,18L18.41,16.59L13.83,12L18.41,7.41M12.41,7.41L11,6L5,12L11,18L12.41,16.59L7.83,12L12.41,7.41Z" /></svg>
                    </div>
                </div>

                <select v-model="user_selected" multiple style="width: 200px; height: 140px; float: left;">
                    <option v-for="u in users" :key="u">{{ u }}</option>
                </select>
            </div>
        </div>
        <div v-if="flagtype=='percentage'" style="clear: both;margin-bottom: 10px;">
            <div style="float: left; width: 120px; margin-bottom: 10px;">
                <div style="float: left;">Percentage</div>
                <info-tooltip margin-left="50px">
                    <p>
                        All users (logged in or not) are given a random number between 1 and 100.
                        Moving the percentage will include that percent of users.
                    </p>
                </info-tooltip>
            </div>
            <input type="range" min="1" max="100" placeholder="Percent" v-model="percentage" onchange="this.percentage_value=this.percentage">
            <span>{{this.percentage}}</span>
        </div>
        <div v-if="flagtype=='system'" style="clear: both; margin-bottom: 10px;">
            <div style="float: left; width: 120px;">
                <div style="float: left;">Active</div>
                <info-tooltip margin-left="50px">
                    <p>
                        Turn a feature on or off
                    </p>
                </info-tooltip>
            </div>
            <input type="radio" v-model="active" :value="0" />OFF
            <input type="radio" v-model="active" :value="1" style="margin-left: 10px;"/>ON
        </div>
        <div style="clear: both; margin-bottom: 10px;">
            <div style="float: left; width: 120px;">
                <div style="float: left;">Debt Date</div>
                <info-tooltip margin-left="50px">
                    <p>
                        Date the flag should be removed from the system.
                        This date has no functionality other than reminding about technical debt.
                    </p>
                </info-tooltip>
            </div>
            <input type="date" placeholder="Debt Date" v-model="debtdate">
        </div>

        <div style="clear: both;">
            <input type="button" class="button" v-if="id==0" @click="addClicked" value="Add"/>
            <input type="button" class="button" v-if="id>0" @click="updateClicked" value="Update"/>
            <input type="button" class="button" v-if="id>0" @click="deleteClicked" value="Delete"/>

            <div class="spinner-border" role="status" v-if="show_working" style="float:right;">
                <span class="visually-hidden">Working...</span>
            </div>
        </div>

        <div class="alert alert-danger" role="alert" v-if="show_error">
            {{ error_message }}
        </div>
        <div class="alert alert-success" role="alert" v-if="show_success">
            {{ success_message }}
        </div>
    </div>
</template>

<style scoped>

</style>
